import Col from "react-bootstrap/Col";
import DropdownButton from "react-bootstrap/DropdownButton";
import DropdownItem from "react-bootstrap/DropdownItem";
import Row from "react-bootstrap/Row"
import Form from "react-bootstrap/Form";
import React, { useState, useEffect } from "react";
import { getPropertyByPath, handleMultipleKeys } from "../../config/utilities";
import { replaceSpaces } from "../../config/utilities";

const GeneralSelector = ({
        clickHandler,
        requestHandler,
        inputPlaceholder = "Search...",
        current = null,
        passedItems = [],
        endpoint = null,
        body = null,
        searchEnabled = false,
        title = "",
        iconClass = "",
        classSelected = null,
        disabled = false,
        defaultItem = null,
        defaultClickHandler = null,
        noContent = "Service down",
        selectorName = null,
        idIndex = "id",
        nameIndex = "name",
        customIndex = null,
        clearSearchContent = true,
        completeSearchContent = false,
        responsePath = "data.content",
        levelIndex = null,
        levelText = "",
        blurFuntion = null
        
    }) => {

    const [items, setItems] = useState(passedItems);
    const [search, setSearch] = useState("");


    function handleInputContent(content){
        if(searchEnabled){
            const input = document.getElementById(`dropdown-search-input-${selectorName}`)
            if(completeSearchContent){
                if(input)input.value = content;
            }else if(clearSearchContent){
                if(input)input.value = "";
            }
        }
    }

    useEffect(() => { 
        (async () => {
            if (endpoint && items.length === 0) {
                let response;
                if(body){ 
                    response = await requestHandler(endpoint, body);
                }else{
                    response = await requestHandler(endpoint);
                }
                if (getPropertyByPath(response, responsePath)) {
                    setItems(getPropertyByPath(response, responsePath));
                }
            }else if( items !== passedItems){
                setItems(passedItems);
            }
        }
        )();
    }, []);

    const addSearchBox = () => {
        if (searchEnabled) {
            return (
                <Form.Control autoComplete="off" placeholder={current ? current : inputPlaceholder} id={`dropdown-search-input-${selectorName}`} onChange={({ target }) => setSearch(target.value.toLowerCase())}/>
            )
        }
        return (
            <span className="px-2" style={{ whiteSpace: "normal"}}>{current}</span>
        )
    }


    let filteredItems = items.filter(item => `${handleMultipleKeys(item,nameIndex)}`.toLowerCase().includes(search))



    useEffect(() => {
        if(!requestHandler){
            if(passedItems.length){
                setItems(passedItems);
            } else if(passedItems.length === 0 && items.length === 0){
                return;
            } else {
                setItems([]);
            }
        }
    },[passedItems])

    return (
        <Row className={`selector ${classSelected} d-fltitleex align-items-center justify-content-xl-center h-100`}>
            <Col xl={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                <i className={iconClass}></i>
                <p className="label d-inline">{title}</p>
                <i className={iconClass}></i>
            </Col>
            <Col xl={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
                <DropdownButton onBlur={() => {blurFuntion && blurFuntion()}} className="d-inline w-100 align-top" disabled={disabled} title={addSearchBox()}>
                    <div
                        style={{ overflow: "auto", maxHeight: "250px" }}
                    >
                    {
                        items.length ?
                        <>  
                            {
                                filteredItems.length === 0 ?
                                
                                <DropdownItem key={`item_${replaceSpaces(selectorName)}_noresults`} as="button" style={{ whiteSpace: "normal"}}>
                                    <span className="px-2">No results</span>
                                </DropdownItem>
                                
                                :
                                <>
                                {
                                    defaultItem &&

                                    function handleDefaultItem(){
                                        
                                        const nameIndexItem = handleMultipleKeys(defaultItem,nameIndex);
                                        const idIndexItem = handleMultipleKeys(defaultItem,idIndex);
                                        const levelIndexItem = handleMultipleKeys(defaultItem,levelIndex);

                                        return(
                                            <DropdownItem key={`item_${nameIndexItem}`} as="button" onClick={e => { e.preventDefault(); defaultClickHandler && defaultClickHandler(); clickHandler(defaultItem); handleInputContent(`${nameIndexItem}`);}} style={{ whiteSpace: "normal"}}>
                                                {levelIndexItem && <b className="item_level">{levelText}{levelIndexItem}</b>}
                                                <span className="px-2">{`${idIndexItem ? idIndexItem + "-" : ""} ${nameIndexItem} ${customIndex ? `(${handleMultipleKeys(defaultItem, customIndex)})` : ""}`}</span>
                                            </DropdownItem>
                                        )
                                    }()
                                }
                                {filteredItems.map((item, x) => {
                                    
                                    const nameIndexItem = handleMultipleKeys(item,nameIndex);
                                    const idIndexItem = handleMultipleKeys(item,idIndex);
                                    const levelIndexItem = handleMultipleKeys(item,levelIndex);

                                    return (
                                        <DropdownItem disabled={item.disabled ? item.disabled : false} key={`item_${nameIndexItem}_${x}`} as="button" onClick={e => { e.preventDefault(); clickHandler(item);  handleInputContent(`${nameIndexItem}`);}} style={{ whiteSpace: "normal"}}>
                                            {levelIndexItem && <b className="item_level">{levelText}{levelIndexItem}</b>}
                                            <span className="px-2">{`${idIndexItem ? idIndexItem + "-" : ""} ${nameIndexItem} ${customIndex ? `(${handleMultipleKeys(item,customIndex)})` : ""}`}</span>
                                        </DropdownItem>
                                    )

                                })}
                                </>
                            }
                        </>
                        :
                        <DropdownItem as="button">
                            <span className="px-2">{noContent}</span>
                        </DropdownItem>
                    }
                    </div>
                </DropdownButton>
            </Col>
        </Row>
    )
}
export default GeneralSelector;
